import TagManager from 'react-gtm-module';

import { GTM_ID } from '^configs/environments';
import IGTMEvent from '^types/gtm/IGTMEvent';
import GTMEventCategory from '^enums/gtm/GTMEventCategory';
import IGTMDimension from '^types/gtm/IGTMDimension';
import TGTMDataLayer from '^types/gtm/TGTMDataLayer';
import ApplicationConfig from '^services/ApplicationConfig';

enum Event {
  Default = 'GAEvent',
  CustomDimensionsUpdate = 'CustomDimensionsUpdate',
}

const APPLICATION_NAME = 'CarColorViewer';
const defaultDimension: IGTMDimension = {
  utmSource: window.xprops.utmSource,
  utmMedium: window.xprops.utmMedium,
  utmCampaign: window.xprops.utmCampaign,
  trackingClickId: window.xprops.trackingClickId,
  trackingId: window.xprops.trackingId,
  variantCode: ApplicationConfig.variantCode,
  originalLocation: window.location.href,
  applicationName: APPLICATION_NAME,
};

class GTMHelper {
  private currentDimension: IGTMDimension = defaultDimension;

  private emitGTMEvent = (dataLayer: Partial<TGTMDataLayer>): void => {
    TagManager.dataLayer({
      dataLayer,
    });
  };

  public init = (): void => {
    if (!GTM_ID) {
      return;
    }

    TagManager.initialize({
      gtmId: GTM_ID,
    });

    this.updateDimension(defaultDimension);
  };

  public updateDimension = (dimension: IGTMDimension): void => {
    this.currentDimension = {
      ...this.currentDimension,
      ...dimension,
    };

    this.emitGTMEvent({
      event: Event.CustomDimensionsUpdate,
      ...this.currentDimension,
    });
  };

  public emitEvent = (category: GTMEventCategory, action: string, label: string = ''): void => {
    const dataLayer: IGTMEvent = {
      event: Event.Default,
      eventLabel: label,
      eventCategory: category,
      eventAction: action,
      ...this.currentDimension,
    };

    this.emitGTMEvent(dataLayer);
  };
}

export default new GTMHelper();
